module.exports = __webpack_public_path__ + "img/progress_099.83f280bd.png";